/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Main Routes file
 */

import React from "react";
import { Route, Switch } from "react-router-dom";

import ProtectedRoute from "./hoc/ProtectedRoute";
import ClosedRouteForUser from "./hoc/ClosedRouteForUser";

import LoginAttemptsExhausted from "./components/loginAttemptsExhausted";

//Schrocken Admin Routes
import SchrockenAdminSettings from "./components/schrockenAdmin/settings";
import AdminDashboard from "./components/schrockenAdmin/dashboard";

// Authentication Routes
import Signup from './components/authentication/signup';
import AzureSignUpRedirect from './components/authentication/azureSignup/AzureSignUpRedirect';
import AzureSignUp from './components/authentication/azureSignup';
import TwoStepAuth from './components/schrockenAdmin/twoStepAuth';
import Login from './components/authentication/login/index';
import ResetPassword from './components/authentication/password/resetPassword';
import ConfirmPassword from './components/authentication/password/confirm';
import ResetPasswordCompleted from './components/authentication/password/passwordResetComplete';
import AzureLogin from './components/authentication/azureLogin';
import Terms from './components/terms/terms';
import Home from './components/home';
import ErrorPage500 from './components/errorPage500';
import ErrorPage404 from './components/errorPage404';
import ContactAdmin from './components/contactAdmin';
import DeactivatedUser from './components/deactivatedUser';
// PCMP APP Route
import PCMP from './components/pcmp/PcmpRoutes';

import MultiUserDashboard from './components/multiUserDashboard';
import AuthFailed from './components/authFailed/index';
import SessionTimeoutPage from './components/sessionTimeout';

import RequestMailSent from './components/contactAdmin/RequestMailSent';
import SwitchEcosystem from './components/userEcosystems/SwitchEcosystem';
import DocusignReturn from "./components/common/DocusignReturn";
//ping Route
// imports
import PingLogin from './components/authentication/PingLogin';
import PingSignUpRedirect from './components/authentication/PingSignup/PingSignUpRedirect';
import PingSignUp from './components/authentication/PingSignup';

const Routes = () => (
  <Switch>
    <Route exact path='/' name='Home Route' component={ProtectedRoute(Home)} />
    <Route
      path='/schrockenAdmin/dashboard'
      name='schrockenAdmin dashboard'
      component={ProtectedRoute(AdminDashboard)}
    />
    <Route
      path='/schrockenAdmin/settings'
      name='Mosymphony Settings'
      component={ProtectedRoute(SchrockenAdminSettings)}
    />
    <Route
      exact
      path='/signup/:signupToken'
      name='User signup'
      component={Signup}
    />
    {/**Azure user Sign up */}
    <Route
      exact
      path='/azuresignup'
      name='User signup'
      component={AzureSignUpRedirect}
    />
    <Route
      exact
      path='/confirmazuresignup/:signupToken'
      name='User signup'
      component={AzureSignUp}
    />
    <Route
      exact
      path='/login'
      name='Login'
      component={ClosedRouteForUser(Login)}
    />
    <Route
      exact
      path='/sessiontimeout'
      name='Session Timeout'
      component={SessionTimeoutPage}
    />
    <Route
      path='/resetpassword'
      name='Reset Password'
      component={ResetPassword}
    />
    <Route
      exact
      path='/confirmpassword/:resetPasswordToken'
      name='Confirm password'
      component={ConfirmPassword}
    />

    <Route
      exact
      path='/resetpasswordcompleted'
      name='Reset Password Completed'
      component={ResetPasswordCompleted}
    />
    <Route
      exact
      path='/contactadmin'
      name='Contact Admin'
      component={ContactAdmin}
    />
    <Route
      path='/twostepauth'
      name='2 step authentication'
      component={TwoStepAuth}
    />

    <Route
      exact
      path='/passwordexpiry/:resetPasswordToken'
      name='Confirm password'
      component={(props) => <ConfirmPassword passwordExpired />}
    />
    <Route
      exact
      path='/error500'
      name='500 Error Page'
      component={ErrorPage500}
    />
    <Route
      exact
      path='/pageNotFound'
      name='404 Error Page'
      component={ErrorPage404}
    />
    <Route
      exact
      path='/deactivateduser'
      name='User Deactivated Error Page'
      component={DeactivatedUser}
    />
    <Route
      exact
      path='/loginexhausted'
      name='Login attempts exhausted'
      component={LoginAttemptsExhausted}
    />

    <Route
      path='/userecosystems'
      name='User Ecosystems'
      component={MultiUserDashboard}
    />

    <Route
      exact
      path='/authfailed'
      name='2 step auth failed'
      component={AuthFailed}
    />
    <Route
      exact
      path='/azurelogin'
      name='azure redirect screen'
      component={AzureLogin}
    />

    <Route
      exact
      path='/requestmailsent'
      name='Request sent'
      component={RequestMailSent}
    />

    <Route
      exact
      path='/terms'
      name='Terms'
      // component={Auth(Terms, null)}
      component={Terms}
    />
    {/**Switch Ecosystems */}
    <Route
      exact
      path='/switch-ecosystem'
      name='Switch Ecosystems of User'
      component={SwitchEcosystem}
    />

<Route
      exact
      path='/docusign-return'
      name='Docusign Return'
      component={DocusignReturn}
    />
{/* ping redirect/callback (login) */}
    <Route
      exact
      path='/pingAMLogin'
      name='ping redirect screen'
      component={PingLogin}
    />
{/* ping redirect/callback (signup) */}
    <Route
      exact
      path='/pingAMSignUp'
      name='ping signup redirect'
      component={PingSignUpRedirect}
    />
{/* ping signup form (two-step) */}
    <Route
      exact
      path='/confirmpingsignup/:signupToken'
      name='ping signup form'
      component={PingSignUp}
    />
    {/* PCMP Routes */}
    <Route path='/pcmp' name='PCMP Layout' component={PCMP} />
    <Route name='404 Not Found' component={ErrorPage404} />
  </Switch>
);

export default Routes;